
export default {
  props: {
    logo: {
      type: String,
      required: true,
    },
  },
}
